exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dependencies-editor {\n  color: #666666;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #cccccc; }\n", ""]);

// exports
